module.exports = __webpack_public_path__ + "img/arriba.f6a72dfa.png";